import { useEffect } from 'react';

/**
 * Listen for a keypress event on the document element with the given key.
 * Returns a function that removes the listener.
 * @param key
 * @param cb
 * @returns
 */
export function useHotKey(key: string, cb: (event: KeyboardEvent) => void) {
  useEffect(() => {
    const globalKeyListener = function globalKeyListener(event: KeyboardEvent) {
      // check whether key matches
      if (event.key === key) {
        cb(event);
      }
    };
    document.documentElement.addEventListener('keydown', globalKeyListener);
    return function removeGlobalKeyListener() {
      document.documentElement.removeEventListener('keydown', globalKeyListener);
    };
  });
}
